const log = (function (environment) {
  if (environment === "prod") {
    return () => {};
  }
  return (...args) => {
    console.log(...args);
  };
})(process.env.REACT_APP_API_ENV);

export { log };
